module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="size-and-position-properties"></div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/widgets/compositeWidget/CompositeWidgetPropertiesView.tpl
// module id = 1783
// module chunks = 0